import { createBrowserHistory, createMemoryHistory } from 'history';

// Shared history instance for the react-router v5 <Router>. Replaces react-router
// 3's `browserHistory` singleton so that imperative navigation from non-React /
// Backbone code (history.push / history.goBack) drives the same history the
// Router listens to.
//
// These modules are also imported by the Node server (SSR of the initial HTML),
// where there is no DOM. createBrowserHistory throws without one, so fall back to
// an in-memory history on the server.
const hasDom = typeof document !== 'undefined' && !!document.createElement;
const history = hasDom ? createBrowserHistory() : createMemoryHistory();

// The app builds navigation targets with getInternalWebsiteBaseUrl, which returns
// absolute, same-origin URLs (https://host/3/agenda/…). react-router 3 tolerated
// those in push(); history v4 / react-router v5 expect a path. Normalize a
// same-origin absolute URL to its path so existing call sites keep working.
export const toAppPath = to => {
    if (typeof to !== 'string' || !/^https?:\/\//.test(to) || typeof window === 'undefined') {
        return to;
    }
    try {
        const url = new URL(to);
        return url.origin === window.location.origin
            ? url.pathname + url.search + url.hash
            : to;
    } catch (e) {
        return to;
    }
};

['push', 'replace'].forEach(method => {
    const original = history[method].bind(history);
    history[method] = (to, state) => original(toAppPath(to), state);
});

export default history;
